package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun FireballMetadata() {
    SpellMetadata(
        spellIndex = "fireball",
        castingTime = "1 action",
        range = "150 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A tiny ball of bat guano and sulfur.",
        duration = "Instantaneous",
        damageBase = "Fire 8d6",
        damageScaling = mapOf("3" to "8d6", "4" to "9d6", "5" to "10d6", "6" to "11d6", "7" to "12d6", "8" to "13d6", "9" to "14d6"),
        savingThrow = "DEX (Half)",
        aoe = "20-ft Sphere",
        concentration = false
    )
}
